import { translationsEn } from "./en";
import { translationsAr } from "./ar";

export const resources = {
    en: { translation: translationsEn },
    ar: { translation: translationsAr },
};
